import { useLocation } from 'react-router-dom'

/**
 * 페이지 주소의 id 가져오는 hook
 * @param index url split해서 가져올 index
 * @returns number | undefined
 */
function useParamId(index?: number) {
  const location = useLocation()

  const popId = typeof index === 'number' ? location.pathname.split('/')[index] : location.pathname.split('/').pop()

  const paramId = Number(popId)

  return !isNaN(paramId) ? paramId : undefined
}

export default useParamId
